import styled from 'styled-components';

export const AnswerLabel = styled.strong`
  color: #f92672;
`

export const QuestionLabel = styled.strong`
`



/** WEBPACK FOOTER **
 ** ./src/Components/Labels.js
 **/